export class PucaQuestionnaireModel {
	isFirstQuestionSelected: string = "2";
	FirstQuestion: FirstQuestion = new FirstQuestion();
	isSecondQuestionSelected: boolean;
	SecondQuestion: SecondQuestion = new SecondQuestion();
	isThirdQuestionSelected: boolean;
	ThirdQuestion: ThirdQuestion = new ThirdQuestion();
	ForthQuestion: ForthQuestion = new ForthQuestion();
	isForthQuestionSelected: boolean;
	AllQuestionsNo: AllQuestionsNo = new AllQuestionsNo();
}

export class FirstQuestion {
	University: String;
	UniversityDepartment: String;
	UniversityRanking: number = null;
	UniversityRankingLink: string;
	AdmissionSemester: String;
	AreaOfResearch: String;
	isCurrentEmployement: boolean = false;
	Employment: String;
	Age: String;
	AdmissionYear: String;
	isQsSubjectRanking: boolean = false;
	qsSubjectRank;
}

export class SecondQuestion {
	University: String;
	UniversityDepartment: String;
	UniversityRanking: number = null;
	UniversityRankingLink: string;
	AdmissionSemester: String;
	AreaOfResearch: String;
	isCurrentEmployement: boolean = false;
	Employment: String;
	Age: String;
	AdmissionYear: String;
	isQsSubjectRanking: boolean = false;
	qsSubjectRank;
}

export class ThirdQuestion {
	University: String;
	UniversityDepartment: String;
	AdmissionSemester: String;
	AreaOfResearch: String;
	isCurrentEmployement: boolean = false;
	Employment: String;
	Age: String;
	AdmissionYear: String;

}

export class ForthQuestion {
	isGRE: boolean = false;
	GRE: GREScore = new GREScore();
	isHAT: boolean = false;
	HAT: HATScore = new HATScore();
	AreaOfResearch: String;
	isCurrentEmployement: boolean = false;
	Employment: String;
	Age: String;
}

export class AllQuestionsNo {
	AreaOfResearch: String;
}

export class GREScore {
	TestDate: String;
	RegistrationNumber: String;
	VerbalReasoning: String;
	QuantitativeReasoning: String;
	Total: String;
	Percentage: String;
	AnalyticalWriting: String;
}

export class HATScore {
	TestDate: String;
	RegistrationNumber: String;
	TotalScoreObtained: String;
	PercentageObtained: String;
	TestCentre?: any;
}
